// Util.js

require('datejs');

import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from '../../components/Common/CommonModal';
import MultilingualContainer from '../../components/Multilingual/MultilingualContainer';

import $ from 'jquery';
import _ from 'lodash';
import {Model} from 'backbone';
import constants from "Constants";
import Immutable    from 'immutable';
import DocumentationService      from 'DocumentationService';
import listService     from 'ListService';
import toolboxItemMapService from 'ToolboxItemMapService';
import userService      from 'UserService.js';
import undoService      from 'UndoService';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView";
import HelpCenterView       from 'HelpCenterView.js';

import Moment from 'moment';
import AlertDialogView      from 'common-views/AlertDialogView.js';
import eventBus from 'EventBus.js';
import notificationService  from 'NotificationService';
import leftPanelStateService from '../LeftPanelStateService';
import sequenceService from 'SequenceService';

 
//==================================================================
// General utility methods
//==================================================================
class Util {
    
	//==================================================================
	// Return Jquery object for a DOM ID string
	//==================================================================
	jqId( anId ) {
		return $( constants.ID_SEL + anId );
	}


	//==================================================================
	// Return Jquery object for a CSS class string
	//==================================================================
	jqCls( aClass ) {
		return $( constants.CLASS_SEL + aClass );
	}


	//==================================================================
	// Return numeric from a dom point such as "left" value of 134px.
	//==================================================================
	extractNum(str)  {
	    return _.isString( str ) ? Number(str.replace(/[^-\d\.]/g, '')) : str;
	}

	//==================================================================
	// Return a dimension value decremented by bracketed border width..
	// Accepts a CSS width or height. E.g. 134px
	// Returns the raw numeric value. E.g. 128
	//==================================================================
	shrink( dimValue )  {
        const accumBorderWidth = constants.ACCUM_BRACKETED_BORDER_WIDTH;
		return this.extractNum( dimValue ) - accumBorderWidth;
	}

    //==================================================================
    // Return x squared, where x numbe be a number.
    //==================================================================
    square(x) {
        return x * x;
    }


    measureCalendar(font) {
        let _font = font ? font : (listService.accountSettings.DefaultFontSelected || 'verdana') + ',10,normal,normal';
        let fontParts = _font.split(',');

        const fontParts2 = fontParts[2] ? fontParts[2].replace('!important','') : '';
        const fontParts3 = fontParts[3] ? fontParts[3].replace('!important','') : '';

        const $tmp = $(`<div></div>`)
            .css({
                'position': 'absolute',
                'float': 'left',
                'white-space': 'nowrap',
                'visibility': 'hidden',
                'fontFamily': fontParts[0],
                'fontSize': fontParts[1],
                'font-weight': fontParts2,
                'font-style': fontParts3
            })
            .appendTo($('body'));

            $tmp.datepicker({
    			changeYear: true, 
    			changeMonth: true, 
    			gotoCurrent: true,    			
			    beforeShow: function( opts ){
			           $tmp.css('font-size', fontParts[1]);
			    }
			});
            $tmp.datepicker('disable');



        var sizes = [$tmp.width() + 3, $tmp.height() + 3];
        $tmp.remove();

        //console.log(width);
        return sizes;
    }

    //==================================================================
    // Get pixel width of measured text width for given font
    //==================================================================
    measureText(text, font, additionalCss = {}) {
        let _font = font ? font : (listService.accountSettings.DefaultFontSelected || 'verdana') + ',10,normal,normal';
        let fontParts = _font.split(',');

        const fontParts2 = fontParts[2] ? fontParts[2].replace('!important','') : '';
        const fontParts3 = fontParts[3] ? fontParts[3].replace('!important','') : '';

        const $tmp = $(`<div>${text}</div>`)
            .css(_.extend({
                'position': 'absolute',
                'float': 'left',
                'white-space': 'nowrap',
                'visibility': 'hidden',
                'fontFamily': fontParts[0],
                'fontSize': fontParts[1],
                'font-weight': fontParts2,
                'font-style': fontParts3
            }, additionalCss))
            .appendTo($('body'));

        const width = $tmp.width() + 1;
        $tmp.remove();
        
        return Math.round(width);
    }


    measureTextHeight(text, font, containerWidth) {
        let _font = font ? font : (listService.accountSettings.DefaultFontSelected || 'verdana') + ',10,normal,normal';
        let fontParts = _font.split(',');
        const fontParts2 = fontParts[2] ? fontParts[2].replace('!important','') : '';
        const fontParts3 = fontParts[3] ? fontParts[3].replace('!important','') : '';

        const $tmp = $(`<div class="wordwrap" style="width: ` + containerWidth + `px;">${text}</div>`)
            .css({
                'display':'block',
                'float': 'left',
                'visibility': 'hidden',
                'fontFamily': fontParts[0],
                'fontSize': fontParts[1] + 'px',
                'fontWeight': fontParts2,
                'fontStyle': fontParts3
            })
            .appendTo($('body'));

        const height = $tmp.height();
        $tmp.remove();

        return Math.round(height);
    }

    changeNameFields(name){

        let newName='';
        if(!name){
            return name;
        }
        switch (name.toLowerCase()){
            case 'instanceguid':
                newName='Meta - Instance ID';
                break;
            case 'parentguid':
                newName='Meta - Parent Instance ID';
                break;
            case 'linkid':
                newName='Meta - Link';
                break;
            case 'stagename':
                newName='Meta - Stage';
                break;
            case 'lastdate':
                newName='Meta - Last Submission Date';
                break;
            case 'instancenumber':
                newName='Meta - Instance Number';
                break;
            case 'instancename':
                newName='Meta - Instance Name';
                break;
            case 'versionmajor':
                newName='Meta - Version Major';
                break;
            case 'versionminor':
                newName='Meta - Version Minor';
                break;

            default:
                newName=name.replace('|',' - ');
                break;
        }
        return newName;
    }
    measureHeight(text, font) {
        let _font = font ? font : (listService.accountSettings.DefaultFontSelected || 'verdana') + ',10,normal,normal';
        let fontParts = _font.split(',');

        const fontParts2 = fontParts[2] ? fontParts[2].replace('!important','') : '';
        const fontParts3 = fontParts[3] ? fontParts[3].replace('!important','') : '';

        const $tmp = $(`<div>${text}</div>`)
            .css({
                'position': 'absolute',
                'float': 'left',
                'white-space': 'nowrap',
                'visibility': 'hidden',
                'fontFamily': fontParts[0],
                'fontSize': fontParts[1],
                'font-weight': fontParts2,
                'font-style': fontParts3
            })
            .appendTo($('body'));

        const height = $tmp.height() + 1;
        $tmp.remove();
        return Math.round(height);
    }

    measureListTextHeight(text, font, containerWidth) {
        let _font = font ? font : (listService.accountSettings.DefaultFontSelected || 'verdana') + ',10,normal,normal';
        let fontParts = _font.split(',');
        const fontParts2 = fontParts[2] ? fontParts[2].replace('!important','') : '';
        const fontParts3 = fontParts[3] ? fontParts[3].replace('!important','') : '';

        let listContent = '';
        let _textValue = text.split("\r");
        _textValue.forEach(function(value) {
            listContent += '<li>' + value + '</li>';
        });


        const $tmp = $(`<div><ul>${listContent}</ul></div>`)
            .css({
                'min-width':containerWidth,
                'visibility': 'hidden',
                'fontFamily': fontParts[0],
                'fontSize': fontParts[1],
                'fontWeight': fontParts2,
                'fontStyle': fontParts3
            })
            .appendTo($('body'));

        const height = $tmp.height() + 3;
        $tmp.remove();

        return height;
    }
    //
    measureListTextWidth(text, font, containerHeight) {
        let _font = font ? font : (listService.accountSettings.DefaultFontSelected || 'verdana') + ',10,normal,normal';
        let fontParts = _font.split(',');
        const fontParts2 = fontParts[2] ? fontParts[2].replace('!important','') : '';
        const fontParts3 = fontParts[3] ? fontParts[3].replace('!important','') : '';

        let listContent = '';
        let _textValue = text.split("\r");
        _textValue.forEach(function(value) {
            listContent += '<li>' + value + '</li>';
        });


        const $tmp = $(`<div><ul>${listContent}</ul></div>`)
            .css({
                'white-space': 'pre',
                'position':'absolute',
                'min-height':containerHeight,
                'visibility': 'hidden',
                'fontFamily': fontParts[0],
                'fontSize': fontParts[1],
                'fontWeight': fontParts2,
                'fontStyle': fontParts3
            })
            .appendTo($('body'));

        const width = $tmp.width();
        $tmp.remove();

        return width;
    }

    //==================================================================
    // Helper to replace text according to supplied regexp.
    //==================================================================
    replaceAll(initialString, regex, valueToReplace) {
        return initialString.replace(new RegExp(regex, 'g'), valueToReplace);
    }

    //==========================================================================================
    // Property: Perfect Forms current page position within DOM window
    //==========================================================================================
    get pagePos() {
        const offset = $(constants.PAGESEL_ID).offset();
        return {
            top: offset.top - $(window).scrollTop(),
            left: offset.left - $(window).scrollLeft()
        };
    }


    remove(toRemove, value) {
        var newValue = value;
        if (value) {
            newValue = value.replace(toRemove, '');
        }
        return newValue;
    }


    //===========================================================================================
    // Method that handles the marking of a text control when it's double clicked.
    //===========================================================================================
    handleMarking(currentTarget, modelId) {
        const currentText = currentTarget.innerHTML;
        if (currentTarget.parentNode.attributes.id.value === modelId) {

            if (currentText.includes('<mark>')) {
                this.unMarkText(currentTarget)
            }
            else {
                this.markText(currentTarget)
            }

        }
    }


    markText(element) {
        element.innerHTML = `<mark>${element.innerHTML}</mark>`
    }

    convertFromUnitToPixel(size, unit, dpi){
        let convertedSize;
        let unitHelper = unit;
        if(dpi === ''){
           unitHelper = 'pixel';
        }
        switch (unitHelper){
            case 'inch':
                convertedSize = size * dpi;
                break;
            case 'mm':
                convertedSize = ((size * dpi) / 25.4).toFixed(2);
                break;
            case 'cm':
                convertedSize = ((size * dpi) / 2.54).toFixed(2);
                break;
            case 'point':
                convertedSize = ((size * dpi) / 72).toFixed(2);
                break;
            default:
                convertedSize = size;
                break;
        }

        return convertedSize;
    }

    convertFromPixelToUnit(pixels, dpi, unit) {
        let convertedSize;
        switch (unit) {
            case 'inch':
                convertedSize = pixels / dpi;
                break;
            case 'mm':
                convertedSize = ((pixels / dpi) * 25.4).toFixed(2);
                break;
            case 'cm':
                convertedSize = ((pixels / dpi) * 2.54).toFixed(2);
                break;
            case 'point':
                convertedSize = ((pixels / dpi) * 72).toFixed(2);
                break;
            default:
                convertedSize = pixels;
                break;
        }

        return convertedSize;
    }

    unMarkText(element) {
        element.innerHTML = element.innerHTML.replace('<mark>', '').replace('</mark>', '');
    }
    

    getFormattedDate(stringDate) {
        if (!stringDate) { return;}
        const date = Date.parse(stringDate);
        const formattedDate = ` ( ${date.toString('dd MMM yyyy')} )`;
        return formattedDate;
    }

    formatExpressionDate(date) {
        //Added parse in case there is a NaN in the incoming date, 
        //this was happening in some imported forms from Flash. If there is a NaN the date function converts it to today's date
        let dateStamp = Date.parse(date); 

        let d = dateStamp ? new Date(dateStamp) : new Date();

        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
            'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
        ];

        //let value = ('0' + d.getDay()).slice(-2) + ' ' + monthNames[d.getMonth()+12] + ' ' + d.getFullYear();
        let value = d.getDate() + ' ' + monthNames[d.getMonth()+12] + ' ' + d.getFullYear();

        return value;

    }

    formatExpressionShortDate(date) {
        let d = new Date(this.dateForIE(date));
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let value = d.getDate() + ' ' + monthNames[d.getMonth()] + ' ' + d.getFullYear();
        return value;
    }

    getTime(date, opts) {
        var opts = opts || {
            use24Hour: true,
            useSeconds: true
        };
        var _date = new Moment(date);
        var hh = _date.hours();
        var mm = _date.minutes();
        var ss = _date.seconds();
        var AMPM = '';


        if (mm < 10) {mm = '0' + mm}
        if (ss < 10) {ss = '0' + ss}

        if (!opts.use24Hour) {
            if (hh >= 12) {
                AMPM = ' PM';
                if (hh !== 12) {hh = hh - 12}
            } else {
                AMPM = ' AM';
                if (hh === 0) {hh = 12}
            }
        }
        if (hh < 10) {hh = '0' + hh}

        let timeValue = hh + ':' + mm;
        if (opts.useSeconds) {
            timeValue += ':' + ss;
        }

        timeValue += AMPM;

        return timeValue;

    }

    getLocaleDateTime(utcDateTime){
        const utc = new Date(utcDateTime)
        const localeTime = new Date(utc.getTime() - utc.getTimezoneOffset() * 60 * 1000);
        const locale = utc.toDateString() +" " + localeTime.toLocaleTimeString().split("GMT")[0];
        return locale;   
    }

    formatUTC(utcDateTime){
        const utc = Moment(utcDateTime);
        return utc.format('dddd MMM-D-YYYY h:mm A');
    }

    getDateTime(date) {
        if (!date) {
            return;
        }

        return this.formatExpressionDate(date) + ' ' + this.getTime(date);
    }


    // Converts rgb(255, 1, 2); to "ff0102"
    rgbFnToHex( rgb ){
        const regex = / *rgb\( *(\d+), *(\d+), *(\d+) *\) */g;
        const ary = regex.exec( rgb );
        return this.rgbToHex( ary[1], ary[2], ary[3]);
    }

    rgbToHex(red, green, blue) {
        return `${this.toHex(red)}${this.toHex(green)}${this.toHex(blue)}`;
    }

    toHex(aColor) {
        let n = parseInt(aColor, 10);
        if (isNaN(n)) {
            return "00";
        }
        n = Math.max(0, Math.min(n, 255));

        //console.log( `${ ((n - n % 16) / 16).toString(16) }${(n % 16).toString(16)}` );

        return `${ ((n - n % 16) / 16).toString(16) }${(n % 16).toString(16)}`;
    }

    //==========================================================================================
    // True if string and six hex chars
    //==========================================================================================
    isCssHexColor( v ){
        return v && typeof v === 'string' && v.match( /^[a-fA-F\d]{6}$/g);
    }

    hexToRgb(v) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        let hex = v.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    //==========================================================================================
    // If six hex chars prefix with '#'
    //==========================================================================================
    enforceColorSyntax( v ){
        if (this.isCssHexColor( v )){
            return `#${v}`;
        }
        return v;
    }

    //==========================================================================================
    // Returns copy of arg having leading dash removed.
    // If arg is a problem-child, however, return it unchanged.
    //==========================================================================================
    trimLeadingUnderscore( v ) {
        if (v && typeof v === 'string' && v.charAt(0) === constants.STRING_USCORE.charAt(0)) {
            return v.slice(1);
        }
        return v;
    }

    //==========================================================================================
    // Returns copy of arg having a leading dash prefix.
    // If arg is a problem-child, however, return it unchanged.
    //==========================================================================================
    prefixLeadingUnderscore( v ) {
        if (v && typeof v === 'string') {
            return `${constants.STRING_USCORE}${v}`;
        }
        return v;
    }



    //==========================================================================================
    // Returns copy of arg having leading hash ('#') removed.
    // If arg is a problem-child, hoever, return it unchanged.
    //==========================================================================================
    trimLeadingHash( v ) {
        if (v && typeof v === 'string' && v.charAt(0) === '#'.charAt(0)) {
            return v.slice(1);
        }
        return v;
    }

    getAttentionLevel(levelNumber){
        switch (levelNumber){
            case '0':return 'None';
            case '2':return 'High';
            case '3':return 'Urgent';
            case '4':return 'Very Urgent';
            case '5':return 'Extremely Urgent';
            default:return 'Normal';
        }
    }

    getNotificationAttentionLevel(levelNumber){
        switch (levelNumber){
            case '0':return 'No attention needed';
            case '1':return 'Normal';
            case '2':return 'High';
            case '3':return 'Urgent';
            case '4':return 'Very Urgent';
            case '5':return 'Extremely Urgent';
            default:return 'None';
        }
    }

    getAttentionLevelColor (AttentionLevel) {
        switch (AttentionLevel){
            case '0': return 'black';
            case '1': return '#47b87f';
            case '2': return '#e4e4b4';
            case '3': return '#d5d585';
            case '4': return '#ff6666';
            case '5': return '#cc3333';
            default: return 'black';
        }
    }

    getMyAttentionLevel(levelNumber,isPlus=""){
        switch (levelNumber){
            case '-1':return 'Any';
            case '0': return 'None';
            case '1':return isPlus ? 'Normal': 'Normal +' ;
            case '2':return isPlus ? 'High': 'High +' ;
            case '3':return isPlus ? 'Urgent': 'Urgent +' ;
            case '4':return isPlus ? 'Very Urgent': 'Very Urgent +' ;
            case '5':return 'Extremely Urgent' ;
            default:return 'Any';
        }
    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    processSettings() {

        const settingsXML = userService.getUserSettings();
        let commonGroupJSON = settingsXML.get('_commonGroup'),
            behaviorGroupJSON = settingsXML.get('_behCommonGroup'),
            reportCommonGroupJSON = settingsXML.get('_repCommonGroup'),
            reportBehCommonGroupJSON = settingsXML.get('_repBehCommonGroup');


        // Dev Only Override to reset defaults
        let reloadDefaults = false;
        if (reloadDefaults) {
            commonGroupJSON = undefined;
            behaviorGroupJSON = undefined;
            reportCommonGroupJSON = undefined;
            reportBehCommonGroupJSON = undefined;
        }

        this.loadCommonGroup(commonGroupJSON, 'layout');
        this.loadCommonGroup(behaviorGroupJSON, 'behaviors');
        this.loadCommonGroup(reportCommonGroupJSON, 'report');
        this.loadCommonGroup(reportBehCommonGroupJSON, 'reportBehaviors');
    }

    getCommonDefaults(type) {

        let val = [];

        switch (type) {
            case 'layout':
                val = toolboxItemMapService.getLayoutCommonGroupDefaults();
                break;
            case 'behaviors':
                val = toolboxItemMapService.getBehaviorCommonGroupDefaults();
                break;
            case 'report':
                val = toolboxItemMapService.getReportCommonGroupDefaults();
                break;
            case 'reportBehaviors':
                val = toolboxItemMapService.getReportBehaviorCommonGroupDefaults();
                break;
        }

        return val;
    }

    loadCommonGroup(commonGroupJSON, type) {
        let commonGroupArray = [];

        if (commonGroupJSON) {
            commonGroupArray = JSON.parse(commonGroupJSON);
        } else {
            commonGroupArray = this.getCommonDefaults(type);
        }

        const list = [];
        _.forEach(commonGroupArray, function (item) {
            list.push(item);
        });

        switch (type) {
            case 'layout':
                toolboxItemMapService.updateCommonGroupItems(list);
                break;
            case 'behaviors':
                toolboxItemMapService.updateBehaviorCommonGroupItems(list);
                break;
            case 'report':
                toolboxItemMapService.updateReportCommonGroupItems(list);
                break;
            case 'reportBehaviors':
                toolboxItemMapService.updateReportBehaviorCommonGroupItems(list);
                break;
        }
    }

    //===========================================================================================
    // Function used to validate controls of the Menu Format Section depending on selection.
    //===========================================================================================
    validateMenuItems(count) {
        $('#align').addClass('disabled pf-disable');
        $('#makeSame').addClass('disabled pf-disable');
        $('#spaceEvenly').addClass('disabled pf-disable');
        $('#layer').addClass('disabled pf-disable');
        $('#designerAddGroup').addClass('disabled pf-disable disabledLink');
        $('#designerCut').addClass('disabled pf-disable disabledLink');
        $('#designerCopy').addClass('disabled pf-disable disabledLink');
        $('#designerPaste').addClass('disabled pf-disable disabledLink');
        $('#designerUndo').addClass('disabled pf-disable disabledLink');
        $('#designerRedo').addClass('disabled pf-disable disabledLink');
        $('#designerDelete').addClass('disabled pf-disable disabledLink');
        
        let clipboardSize = listService.clipboardCount;
       
        if (undoService.hasUndo()) {
            $('#designerUndo').removeClass('disabled pf-disable disabledLink');
        }

        if (undoService.hasRedo()) {
            $('#designerRedo').removeClass('disabled pf-disable disabledLink');
        }

        if(clipboardSize > 0){
           $('#designerPaste').removeClass('disabled pf-disable disabledLink');
        }

        // PF-3892: Make paste menu appear on behaviors/workflow tab
        if (listService.behaviorClipboard || listService.workflowClipboard) {
            $('#designerPaste').removeClass('disabled pf-disable disabledLink');
        }

        if (count > -1) {
              $('#designerDelete').removeClass('disabled pf-disable disabledLink');
         }
         
        if (count > 0) {
            if (listService.mainKind === constants.KIND_LAYOUT) {
                $('#layer').removeClass('disabled pf-disable');
            }
            $('#designerAddGroup').removeClass('disabled pf-disable disabledLink');
            $('#designerCut').removeClass('disabled pf-disable disabledLink');
            $('#designerCopy').removeClass('disabled pf-disable disabledLink');            
        }
        if (count > 1) {
            $('#align').removeClass('disabled pf-disable');
            $('#makeSame').removeClass('disabled pf-disable');
        }
        if (count > 2) {
            $('#spaceEvenly').removeClass('disabled pf-disable');
        }
    }

    deleteGridRows(gridId) {
        // get IDs of all the rows odf jqGrid
        let rowIds = $(gridId).jqGrid('getDataIDs');
        // iterate through the rows and delete each of them
        for (let i = 0, len = rowIds.length; i < len; i++) {
            let currRow = rowIds[i];
            $(gridId).jqGrid('delRowData', currRow);
        }
    }

    appendOptionToSelect(selectElement, value, text, isSelected = false, data='') {
        if(isSelected) {
            selectElement.append($('<option>', {
                value: value,
                text: text,
                selected: isSelected,
                dataValue: data
            }))
        }
        else{
            selectElement.append($('<option>', {
                value: value,
                text: text,
                dataValue: data
            }))
        }
    }

    prependOptionToSelect(selectElement, value, text, isSelected = false) {
        if(isSelected) {
            selectElement.prepend($('<option>', {
                value: value,
                text: text,
                selected: isSelected
            }))
        }
        else{
            selectElement.prepend($('<option>', {
                value: value,
                text: text
            }))
        }
    }

    getMessageWarning(id){
        switch (id){
            case "0": return "";
            case "3":return "Limit reached.";
            default:return "";

        }
    }

    getSizeInMb(size){
        return parseInt(parseInt(size) / 1024 / 1024) + " Mb";
    }

    getGridObject(view,options={}, afterSelect){
        let defaultGridParameters={
            datatype: "local",
            shrinkToFit: true,
            altRows: true,
            cellEdit: true,
            maxHeight: 200,
            minHeight: 90,
            cellsubmit : 'clientArray',

            gridComplete: function() {
                $(view.gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
            },

            //jsonReader : {root: this.model.get('rows') },
            colNames: view.model.get('colNames'),
            colModel: view.model.get('colModel'),
            onCellSelect: function(rowid, iCol, cellcontent,e){
                view.onCellSelect(rowid, iCol, cellcontent,e);
            },
            onSelectRow: function(rowId, status,e){
                view.onSelectRow(rowId, status, e, this, afterSelect);
            },
            ondblClickRow:function(rowId,iRow,iCol,e){
                view.onDoubleClickRow(rowId,iRow,iCol,e);
            },
            beforeSelectRow: function (rowId,e) {
                view.setRow(rowId,e);
            },
            afterSaveCell:function(rowId, cellName, value, iRow, iCol){
                view.afterSaveCell(rowId, cellName, value, iRow, iCol);
            },
            afterEditCell:function(rowId, cellName, value, iRow, iCol){
                view.afterEditCell(rowId, cellName, value, iRow, iCol);
            },
            onSelectAll: function(aRowids, status){
                view.onSelectAll(aRowids, status, this, afterSelect);
            }
        };
        return Object.assign({},defaultGridParameters,options);
    }

    //Convert the first letter of a string to lowercase
    firstToLowerCase( str ) {
        let result;
        if (typeof str !== 'string' || !str){
            result = '';
        }else{
            result = str.substr(0, 1).toLowerCase() + str.substr(1);
        }

        return result;
    }

    //Convert the first letter of a string to uppercase and the rest to lowercase
    capitalize(str){
        let result;
        if (typeof str !== 'string' || !str){
            result = '';
        }else{
            result = str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase();
        }

        return result;
    }


    getRole(roleNumber){
        switch(roleNumber){
            case "3": return 'Limited';
            case "1": return 'Basic';
            case "2": return 'Full';
            default: return 'Any'
        }
    }


    //==============================================================
    // Handy for working with XML-to-JSON objects that could
    // parse as either a JSON object or a JSON array.
    //
    // Forces an item to be an array:
    // If arg IS NOT an array, returns arg converted to an array.
    // If arg IS an array, returns arg;
    //==============================================================
    enforceArrayType(arg ){
        const result = Array.isArray( arg ) ? arg : [];
        if (!result.length) {
            result.push( arg );
        }
        return result;
    }

    /***   Validate color on input text fields ***/
    isValidColorcode(colorcode) {
        let result = false;
        var regColorcode = /^(#)?([0-9a-fA-F]{3})([0-9a-fA-F]{3})?$/;
        if(regColorcode.test(colorcode) === true) {
            result = true;
        }
        return result;
    }


    // Method that generates a CSV file based on an array of objects.
    generateCSV(data, header){

        // Bulding the response so the browser can download it.
        let csvContent = "data:text/csv;charset=utf-8,";

        if (header) {
            header.forEach(function(item){
                csvContent += item + ',';
            });
            csvContent=csvContent.slice(0,-1) + '\n';
        }
        data.forEach(function(item){
            $.each(item, function(key) {
                if (key!=='id'){
                 csvContent += item[key] + ',';
                }
            });
            csvContent=csvContent.slice(0,-1) + '\n';
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "behavior_data.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
    }

    isTrue( value ) {
        let answer = false;

        if (value) {
            let valueString = value.toString();
            if (valueString.toLowerCase() === 'true' || value === true || valueString==='1'
                || valueString.toLowerCase() === 'yes' || valueString.toLowerCase() === 'on') {
                answer = true;
            }
        }

        return answer;

    }

    isEmpty( value ) {
        let answer = false;

        if (value) {
            // TODO replace if by: answer = !value.toString().toLowerCase() === 'null' || value.toString()==='undefined');
            if (value.toString().toLowerCase() === 'null' || value === false || value.toString()==='undefined') {
                answer = true;
            }
        } else {
            answer = true;
        }

        return answer;

    }

    isEmptyObject(obj) {
        for(let key in obj) {
            if(this.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    _unPrefix( props ) {
        const p = Immutable.Map( ).asMutable();

        Immutable.Map( props ).map( (v,k) => {
            //const v2 = this._condApplyTheme( v );

            if (k) {
                p.set(k.replace(constants.XATTR_PREFIX, constants.STRING_EMPTY), v);
            }
        });
        const pj = p.toJS();
        return pj;
    }

    _unPrefixAmp( props ) {
        const p = Immutable.Map( ).asMutable();

        Immutable.Map( props ).map( (v,k) => {

            if (k) {
                p.set(k.replace('@', constants.STRING_EMPTY).toCamelCase(), v);
            }
        });
        const pj = p.toJS();
        return pj;
    }

    applyPrefix(props) {
        const p = Immutable.Map().asMutable();
        Immutable.Map(props).map((v, k) => {
            p.set(k.indexOf("_") === 0 ? k : constants.XATTR_PREFIX + k, v);
        });

        const pj = p.toJS();
        return pj;
    }

    // This function recovers the connection point coordinates and uses the widgets refed by owners object.
    getCommandCoordInfo(connection) {

        // Note: owners object contains the two fabric.js endpoint widgets created in pass one of the behavior render loop
        const
            srcDotNum  = parseInt(connection.srcDot),    // Dot number 0 .. 3 is needed coon index - 1
            destDotNum = parseInt(connection.destDot);    // Dot number 0 .. 3 is needed coon index - 1;

        const
            model1 = connection.srcCommand.model,
            model2 = connection.destCommand.model;

        const
            cp1 = model1.get('widget')._objects[ srcDotNum + 1 ],
            cp2 = model2.get('widget')._objects[ destDotNum +1 ];

            
        const 
            strokeWidth = constants.CONN_STROKE_WIDTH, //PF-5194 Giving more width to the stroke so the click does not have to be exactly on the line
            lineOffset = strokeWidth / 2; //Offset created by the stroke width

        const coords = [
            Number(cp1.left) + cp1.width/2 + cp1.group.left + cp1.group.width/2 - lineOffset,
            Number(cp1.top)  + cp1.width/2 + cp1.group.top  + cp1.group.height/2 - lineOffset,
            Number(cp2.left) + cp2.width/2 + cp2.group.left + cp2.group.width/2 - lineOffset,
            Number(cp2.top)  + cp2.width/2 + cp2.group.top  + cp2.group.height/2 - lineOffset
        ];

        // Result is an info object
        const cobj = {
            coords: coords,
            srcDot: srcDotNum, destDot: destDotNum,
            src: connection.srcCommand, dest: connection.destCommand };
        return cobj;
    }

    _fixColorFormat( color ) {
        let newValue = color;

        if (newValue) {
            if (newValue.length > 1) {
                if ( (newValue.substring(0,1) !== '#') && (newValue.substring(0,1) !== '~') ) {
                    newValue = '#' + newValue;
                }
            }
        }

        return newValue;
    }

    regexValidation(value, regexExpression){
        let isValid = false;
        if (typeof value !== 'undefined' && typeof regexExpression !== 'undefined'){
            isValid = value.toString().search(regexExpression) >= 0;
        }

        return isValid;
    }

    // Force file extension to lowercase
    forceLowercaseExt( arg ){
        const ext = arg.split('.').pop().toLowerCase();
        const name = arg.substr(0, arg.length - ext.length - 1);
        const r = `${name}.${ext}`;

        return r;
    } 

    hasEventListener (events, existingEvent) {
        
        let r = _.find(events, (e, i) => {
            return i === existingEvent;
        }); 

        return r ? r.length !== 0 : false;
    }

    resizeGridWidth(factory) {
        let grids = $('#settings .ui-jqgrid-btable');
        let commands = ["command_connect_search", "command_connect"];
        let commandsWithoutScroll = ["command_connect_search", "command_connect"];
        let commandsLikeTables = ["control_data_grid", "control_data_list"];
        let containsTables = false;

        let lookForObject = (objectList, id) => {
            let o = objectList.toArray().find(o =>
                o.model.get("id") === id
            );
            
            return o ? o.model.get("factoryKey") : o;
        }

        let controlModel = undefined;
        let adaptContainer = undefined;  

        if (listService.behaviorObjectList.size && listService.mainKind === constants.KIND_BEHAVIORS) {
            controlModel = lookForObject(listService.behaviorObjectList, listService.currentBehaviorId);  
        }

        if (listService.objectList.size && (listService.mainKind === constants.KIND_LAYOUT || listService.mainKind === constants.KIND_REPORT))  {
            controlModel = lookForObject(listService.objectList, listService.currentId);     
        }

        if (controlModel) {
            adaptContainer = commands.find(command => controlModel === command); 

            containsTables = _.includes(commandsLikeTables, controlModel);
        }  

        let settingsWidth  = 0;
        if (listService.mainKind === constants.KIND_WORKFLOW || controlModel === 'command_notify') {
            settingsWidth =  $('.settings-style-access').width() - 40;
        }
        else {
            let difference = -25;
             
            if ((adaptContainer !== undefined || !controlModel || containsTables) && !listService.isTableColumnSelected) {
                difference = -45;
            }

            settingsWidth =  $('.settings-style-access').width() + difference;
        }
        
        if (grids.length) {

            grids.each(function() {
                let gridId = $(this).attr('id'); 
                let grid = $('#settings  #' + gridId);   
                 
                //if (listService.mainKind !==  constants.KIND_BEHAVIORS) {
                    grid.setGridWidth(settingsWidth); 
                //}
                
                if (factory && _.includes(commandsWithoutScroll, factory)) {
                    grid.setGridWidth(settingsWidth); 
                    grid.closest(".ui-jqgrid-bdiv").css("overflow", "hidden"); 
                }
            });
        }
    }

    showConfirmationDashboardChangesModal(applyChangesElement,performActionFunc,confirmationText,subtitle,ev,caller){
        let performActionBoundFunction=performActionFunc.bind(caller);
        if($(applyChangesElement).is(':visible')){
            let simpleConfirmModalView= new SimpleConfirmModalView(
                {
                    model:new Model(
                        {
                            confirmationText:confirmationText,
                            subtitle:subtitle,
                            height: 'auto',
                            width: 400
                        })
                });
            simpleConfirmModalView.render().then((result)=>{
                if(result === 'Ok'){
                    performActionBoundFunction(ev);
                }
                else{
                    return;
                }
            })
        }
        else{
            performActionBoundFunction(ev);
        }
    }


  getDotNotationFromObject(obj) {
        var res = {};
        (function recurse(obj, current) {
          for(var key in obj) {
            var newKey = '';
            var value = obj[key];                
            key = key.replaceAll(".", constants.CONNECTION_DOT_PLACEHOLDER);

            if(!key.startsWith('_')){
                newKey = (current ? current + "." + key : key);
            }else{
                newKey = (current ? current : key);
            }
            
            if (typeof value !== 'undefined') {
                if (Object.keys(value).length === 0) {
                    res[newKey] = value;
                }else if(typeof value === "object"){
                    recurse(value, newKey);  
                }
            }
          }
        })(obj);
 
        return Object.keys(res); 
    }

    getFormattedTime(date){
        let _date = date;
        if (!_date){
            _date = new Date();
        }
        
        return `${('0' + _date.getHours()).slice(-2)}:${('0' + _date.getMinutes()).slice(-2)}:${('0' + _date.getSeconds()).slice(-2)}`;
    }

    // Selects the correct URL Help Link for a control via its factoryKey.
    updateHelpDocumentationLink(factoryKey) {
        let linkRef = DocumentationService.getPFDocumentationLinkRoot()[factoryKey];
        $('#helpLinkDocumentation').attr('href', linkRef);

        //PF-10258 Context help in quick help
        let text = "";
        const setContextText = () => {
            
            let tempText = factoryKey.replace("control_", "");
            tempText = tempText.split("_");

            _.each(tempText, (str, i) => {
                tempText[i] = str.charAt(0).toUpperCase() + str.slice(1)
            })
            
            tempText = tempText.join(" ");            
            return tempText;
        }

        text = factoryKey === constants.KIND_LAYOUT ? "App" : factoryKey === constants.KIND_REPORT ? "Report" : factoryKey === constants.KIND_MOBILE ? "Mobile" : setContextText();        
        $(".qh-context-help").html(text +  " Help");
        $(".qh-context-help").data("url", linkRef);
    }

    // This JQuery helper marks an HtmL select option as 'selected'.
    selectDropdownItem(propName, propVal ) {
        $(`#${propName}`)
            .find(`option[value="${propVal}"]`)
            .attr(`selected`, true);
    }

    getBrowserZoom(){ 
        let zoom = window.devicePixelRatio;
        const nav = navigator.userAgent.toLowerCase(); 
        if (nav.indexOf('safari') !== -1) { 
          if (nav.indexOf('chrome') === -1) {
            zoom = Math.round(window.outerWidth / window.innerWidth * 100) / 100;
          }
        }
        return zoom;
    }

    escapeStringForConnectionsTest(text){
        return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    escapeSingleQuotes(text){
        return text.replace(/\\/, "\\\\").replace(/'/g, "\\'");
    }

    restoreSingleQuotes(text){
        return text.replace(/\\\\/, "\\").replace(/\\'/g, "'");
    }

    isElementExpanded(element){
        return element.hasClass('collapse') && element.hasClass('in')
    }

    cleanChildNodes(dataTarget){
        $(`${dataTarget} > ul.group-items`).empty();
    }
    cleanSelectedNodeOnDashboard(){
        $('li[role="button"]').removeClass('bg-success');
    }

    disableReloadLink(){
        $('#pf-refresh-main-view').addClass('disable-link');
    }

    enableReloadLink(){
        $('#pf-refresh-main-view').removeClass('disable-link');
    }  

    /**Legacy code section from PresentationServer's util.js  */
    pf_main(e, t, n, r, ult) {
        if (this.DetectFlashVer(9, 0, 115)) {
            this._pf_writeSWF(n, "__pf_app", r, e, t, undefined, ult);
        } else if (this.DetectFlashVer(6, 0, 65)) {
            document.title = document.title.slice(0, 47) + " - Flash Player Installation";
            const isIE = navigator.appVersion.indexOf("MSIE") !== -1;
            this._pf_writeSWF("playerProductInstall.swf", "_id", "MMredirectURL=" + window.location + "&MMplayerType=" + (isIE === true ? "ActiveX" : "PlugIn") + "&MMdoctitle=" + document.title + "", e, t);
        } else {
            this.cleaningBodyTag();
            const $tmp = $('<span>This content requires the Adobe Flash Player.</span> <a href="https://www.adobe.com/go/getflash/">Get Flash</a>').appendTo($('body'));
        }
    }

    DetectFlashVer(e, t, n) {
        let vs = this.GetSwfVer();
        const isIE = navigator.appVersion.indexOf("MSIE") !== -1;
        const isWin = navigator.appVersion.toLowerCase().indexOf("win") !== -1;
        const isOpera = navigator.userAgent.indexOf("Opera") !== -1;

        if (vs === -1) {
            return false
        } else if (vs !== 0) {
            let va = [];
            if (isIE && isWin && !isOpera) {
                let ta = vs.split(" ");
                let ts;
                if(ta.length === 1){
                    ts = ta[0];
                    va = vs.split(".");
                }else{
                    ts = ta[1];
                    va = ts.split(",");
                }
            } else {
                va = vs.split(".")
            }
            let r = va[0];
            let i = va[1];
            let s = va[2];
            if (r > e) {
                return true;
            } else if (r === e) {
                if (i > t){
                    return true;
                } 
                else if (i === t) {
                    if (s >= n){
                        return true;
                    } 
                }
            }
            return false;
        }
    }

    GetSwfVer() {
        let e = -1;
        const isIE = navigator.appVersion.indexOf("MSIE") !== -1;
        const isWin = navigator.appVersion.toLowerCase().indexOf("win") !== -1;
        const isOpera = navigator.userAgent.indexOf("Opera") !== -1;

        if (navigator.plugins !== null && navigator.plugins.length > 0) {
            if (navigator.plugins["Shockwave Flash 2.0"] || navigator.plugins["Shockwave Flash"]) {
                let t = navigator.plugins["Shockwave Flash 2.0"] ? " 2.0" : "";
                let n = navigator.plugins["Shockwave Flash" + t].description;
                let r = n.split(" ");
                let i = r[2].split(".");
                let s = i[0];
                let o = i[1];
                let tm = [];
                if (r[3] !== "") {
                    tm = r[3].split("r");
                } else {
                    tm = r[4].split("r");
                }
                let u = tm[1] > 0 ? tm[1] : 0;
                e = s + "." + o + "." + u;
            }
        } else if (navigator.userAgent.toLowerCase().indexOf("webtv/2.6") !== -1){
            e = 4;
        } else if (navigator.userAgent.toLowerCase().indexOf("webtv/2.5") !== -1){
            e = 3;            
        } else if (navigator.userAgent.toLowerCase().indexOf("webtv") !== -1){
            e = 2;   
        } else if (isIE && isWin && !isOpera){
            e = this.ControlVersion();
        }
        return e
    }
    
    ControlVersion() {
        var e, t, n;
        try {
            t = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7");
            e = t.GetVariable("$version");
        } catch (n) {}
        if (!e) {
            try {
                t = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
                e = "WIN 6,0,21,0";
                t.AllowScriptAccess = "always";
                e = t.GetVariable("$version");
            } catch (n) {}
        }
        if (!e) {
            try {
                t = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.3");
                e = t.GetVariable("$version");
            } catch (n) {}
        }
        if (!e) {
            try {
                t = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.3");
                e = "WIN 3,0,18,0";
            } catch (n) {}
        }
        if (!e) {
            try {
                t = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
                e = "WIN 2,0,0,11";
            } catch (n) {
                e = -1;
            }
        }
        return e;
    }

    //ult = User Login Token
    _pf_writeSWF(e1, t, n1, r, i, s1, ult) {
        let s,n,e;
        if (s1 === undefined){
            s = 'window';  
        }else{
            s = s1
        }
        let o = 'x=false&b=0&q=0';
        if (ult){
            o += '&i=1&ult=' + ult;
        }else{
            o += '&i=0';
        }
        
        if (n1 === undefined) {
            n = o;
        } else {
            n = n1 + '&' + o;
        }
        if (e1.indexOf('player.aspx') !== -1) {
            e = e1.replace('.aspx', '.swf?' + _pf_version);
        }else{
            e = e1;
        }

        this.cleaningBodyTag();
        //Creating flash object
        const $tmp = $('<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="https://fpdownload.macromedia.com/get/flashplayer/current/swflash.cab" width="' + r + '" height="' + i + '" id="' + t + '"><param name="movie" value="' + e + '"></param><param name="wmode" value="' + s + '"></param><param name="flashVars" value="' + n + '"></param><param name="allowScriptAccess" value="always"></param><embed src="' + e + '" type="application/x-shockwave-flash" wmode="' + s + '" width="' + r + '" height="' + i + '" flashVars ="' + n + '" name="' + t + '" allowScriptAccess="always"></embed></object>').appendTo($('body'));

        if (document.body){
            document.body.style.margin = '0px 0px 0px 0px';
        }
    }

    cleaningBodyTag(){
        //Clening body's nodes
        let bodyNode = document.getElementsByTagName("BODY")[0];
        while (bodyNode.firstChild) {
            bodyNode.removeChild(bodyNode.firstChild);
        }    
    }
    /**End of legacy code section */

    /*Help Center Section*/
    setHelpCenterMainKind (mainKindForVideos = 'D') {
        sessionStorage.setItem("mainKindForVideos", mainKindForVideos);
    }

    getHelpCenterMainKind() {
        return sessionStorage.getItem("mainKindForVideos");
    }

    getShowHelpCenter() {
        return Number(listService.userSettings.get('_edShHC'));
    }

    setUpHelpCenterCounters() {
        let counterName = this.getCounterName()
        if (sessionStorage.getItem(counterName) === undefined) {
            sessionStorage.setItem(counterName, 0);
        }      
    }

    increaseHelpCenterCounters() {       
        sessionStorage.setItem(this.getCounterName(), this.getHelpCenterCounters() + 1);
    }

    getCounterName() {
        return "timesDashBoardHelperShown" + this.getHelpCenterMainKind();
    }

    getHelpCenterCounters() {        
        return Number(sessionStorage.getItem(this.getCounterName()));
    }

    isFirstLogin() {        
        return sessionStorage.getItem("isFirstLogin") === 'true';
    }

    canVideoBeSeen() {
        let whereInYoda = this.getHelpCenterMainKind();  
        let counterNameIndex = "timesDashBoardHelperShown" + whereInYoda;
        let canVideoBeSeen = false;
        let isFirstLogin = this.isFirstLogin(); 
        switch (whereInYoda) {
            case constants.KIND_DASHBOARD:
            case constants.KIND_LAYOUT:
            case constants.KIND_REPORT:
                canVideoBeSeen = isFirstLogin && this.getHelpCenterCounters() < 1;
            break;  
        } 

        return canVideoBeSeen
    }

    canDisplayHelpCenter() {
        let howManyTimesPopUpOpen = this.isFirstLogin() ? 2 : 1;
        return this.getHelpCenterCounters() < howManyTimesPopUpOpen && Number(this.getBitPosition(this.getPositionShowHelpCenter())) === 1;
    } 

    openHelpCenter(whereInYoda = constants.KIND_DASHBOARD, forceOpen = false) {
        
        if (this.isTrue(listService.userProfile.HelpCenterEnabled)) {
            this.setHelpCenterMainKind(whereInYoda); 

            if (this.canDisplayHelpCenter() || forceOpen) {
                let _modelObj = {
                    isFirstLogin: this.isFirstLogin(),
                    mainKind: this.getHelpCenterMainKind(), 
                    canVideoBeSeen: this.canVideoBeSeen(),
                    isForcedOpen: forceOpen
                }

                if (whereInYoda === constants.KIND_MOBILE && forceOpen){
                    _modelObj.fromMobileOption = true;
                }

                let model = new Model(_modelObj);

                let view = new HelpCenterView({ model });
                view.render();

                this.increaseHelpCenterCounters();
                this.setStartVideoHelpCenter();
            }              
        } 
    } 
        
    setStartVideoHelpCenter() {        
        if (this.isFirstLogin()) {
            this.setBitPosition(this.getPositionStartVideo(), 0);            
        }       
    }

    getPositionStartVideo() {
        const 
              SHOW_STARTVIDEO_FORMEDITOR = 4,
              SHOW_STARTVIDEO_REPORTEDITOR = 3, 
              SHOW_STARTVIDEO_DASHBOARD = 1;
        let helpCenterBitPosition = 0;

        switch (this.getHelpCenterMainKind()) {
            case constants.KIND_DASHBOARD:
                helpCenterBitPosition = SHOW_STARTVIDEO_DASHBOARD;
            break;
            case constants.KIND_LAYOUT:
                helpCenterBitPosition = SHOW_STARTVIDEO_FORMEDITOR;
            break;
            case constants.KIND_REPORT:
                helpCenterBitPosition = SHOW_STARTVIDEO_REPORTEDITOR;
            break;  
        }

        return helpCenterBitPosition;
    }

    getPositionShowHelpCenter() {
        const SHOW_HELPCENTER_FORMEDITOR = 6,
              SHOW_HELPCENTER_REPORTEDITOR = 5, 
              SHOW_HELPCENTER_DASHBOARD = 2;

        let helpCenterBitPosition = 0;
       
        switch (this.getHelpCenterMainKind()) {
            case constants.KIND_DASHBOARD:
              helpCenterBitPosition = SHOW_HELPCENTER_DASHBOARD;
            break;
            case constants.KIND_LAYOUT:
               helpCenterBitPosition = SHOW_HELPCENTER_FORMEDITOR;
            break;
            case constants.KIND_REPORT:
               helpCenterBitPosition = SHOW_HELPCENTER_REPORTEDITOR;
            break;  
        }  
        
        return helpCenterBitPosition;
    }

    setShowEditorHelpCenter(flag) {
        this.setBitPosition(this.getPositionShowHelpCenter(), flag ? 1 : 0);
    }

    setBitPosition(position, value) {
        listService.userSettings.get('helpCenterConfig')[position] = value;

        let config = listService.userSettings.get('helpCenterConfig').join('');
        
        listService.userSettings.set('_edShHC', parseInt(config, 2));
        sessionStorage.setItem("editorShowHelpCenterChanged", true); 
    }
    
    getBitPosition(position) {
        return listService.userSettings.get('helpCenterConfig')[position];
    }

    removeIfRemainingHelpCenter() {
         let dialog = $( '#dialog-help-center' );

         if (dialog) {
            dialog.dialog( "close" );
            dialog.remove();
            $("#hold-dialog").remove();
         }             
    }

    /*End HelpCenter Section*/

    confirmSaveCloseForms() {

         if (listService.isSaveDialogOpened) {
             return false;
         }

         let confirmationText = "";
            if (undoService.hasChanges()) {
                const
                    isReport = listService.docType === constants.DOC_TYPE_REPORT;
                if(isReport){
                    confirmationText=`Would you like to save the changes you made to this report?`
                }
                else{
                    confirmationText=`Would you like to save the changes you made to this app?`
                }

                let closeFormConfirmationModalView = new CloseFormConfirmationModalView({
                    model: new Model({
                        confirmationText: confirmationText,
                        height: 140,
                        width: 500
                    })
                });

            
                closeFormConfirmationModalView.render().then((result) => {

                    let closeDialog = () => {
                        let dialog = $( '#dialog' );
                        if (dialog) {
                            dialog.dialog( "close" );
                            dialog.remove();
                        }
                    }

                    switch (result) {
                        case 'Yes':
                            listService.linkClicked = true;
                            Backbone.history.loadUrl('saveAndClose');
                            //closeDialog();
                            break;
                        case 'No':
                            listService.linkClicked = true;
                            undoService.clearChangeTracker();
                            Backbone.history.loadUrl('close');
                            //closeDialog();
                            break;
                        default:
                            break;
                    }
                }).catch((err) => {
                    console.log('Error Showing Save App Confirmation Modal', err);
                    notificationService.error('Error Showing Save App Confirmation Modal ' + err.MESSAGE);
                });

                listService.isSaveDialogOpened = true;
            } 
    }

    setDashboardFormsListCache(dashboardFormsListCache) {
        if (dashboardFormsListCache) {
            sessionStorage.setItem("dashboardFormsListCache", JSON.stringify(dashboardFormsListCache));
        } else {
            sessionStorage.removeItem("dashboardFormsListCache");
        }
    }

    getDashboardFormsListCache() {
        return JSON.parse(sessionStorage.getItem("dashboardFormsListCache"));
    }

    setDashboardReportsListCache(dashboardReportsListCache) {
        if (dashboardReportsListCache) {
            sessionStorage.setItem("dashboardReportsListCache", JSON.stringify(dashboardReportsListCache));
        } else {
            sessionStorage.removeItem("dashboardReportsListCache");
        }
    }

    getDashboardReportsListCache() {
        return JSON.parse(sessionStorage.getItem("dashboardReportsListCache"));
    }

    resizeLastColumnOfAGivenGrid(model){
        let tableWidth = parseInt(model.get('width'), 10);
        let gridData = model.get('gridData');

        // Sum the column widths used for decision to extend final col vs insert the horiz scroll bar
        const columnWidthSum = (cModel => {
            let sum = 0;
            _.forEach(cModel, (v, k) => {
                if(k === gridData.length -1){return false;}
                sum += parseInt(v.width);
            });
            return sum;
        })(gridData);


        // Extend final column if and only if table width > sum of column widths
        const dw = tableWidth - columnWidthSum;
        if (gridData.length > 0 && dw > 0) {
            // Extend final column
            $(`#${model.get('id')}`).find('table th:last-child').width(dw);
            $(`#${model.get('id')}`).find('table td:last-child').width(dw);
        }
    }

    removeAllLineBreaks(value){
        return value.replace(/(\r\n|\n|\r)/gm,"");
    }

    isHtmlEncoded(str){
        const noLineBreak = this.removeAllLineBreaks(str);
        const decoded = this.decodeForHTMLNotification(noLineBreak);
        return this.minifyXMLString(decoded) !== this.minifyXMLString(noLineBreak);
    }

    encodeForHTMLNotification(text){
        return text.replace(/</g, '&lt;').replace(/"/g, "&quot;");
    }

    decodeForHTMLNotification(text){
        return text.replace(/&lt;/g, '<').replace(/&quot;/g, "\"");
    }

    escapeXMLString(text){
        return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    minifyXMLString(text, preserveComments = false) {
        let str = preserveComments ? text
            : text.replace(/\<![ \r\n\t]*(--([^\-]|[\r\n]|-[^\-])*--[ \r\n\t]*)\>/g,"")
            .replace(/[ \r\n\t]{1,}xmlns/g, ' xmlns');
        return  str.replace(/>\s{0,}</g,"><");
    }
 
    processArrayResult (result, field) {
        return result[field] instanceof Array ? result[field]: [result[field]];
    }

    inputRenameTree(innerText) {
        return "<input class='newname' style='position: relative; width: 80%; padding-left: 0;' value='" + innerText.trim() + "' type='text' maxLength='50'>"; 
    }

    createDialogDeleteConfirmation(subtitle = '', question= '', showCancel = true, height = 'auto') {
        return new SimpleConfirmModalView({
                model: new Model({subtitle: subtitle,
                confirmationText: question,
                height: height,
                width: 400, 
                showCancel
            })
        }); 
    }

    enableSaveOption(){
        $("[name=designerSave]").removeClass('disabledPanel');
    }

    disableSaveOption(){
        $("[name=designerSave]").addClass('disabledPanel');
    }

    getCurrentRoleName() {
        const
            role = listService.getWorkflowRole(listService.getCurrentRole()),
            roleName = role ? role.name : 'All';
        return roleName;
    }

    getCurrentStageName() {
        const
            stage = listService.getWorkflowStage(listService.getCurrentStage()),
            stageName = stage ? stage.model.get('name') : 'All';
        return stageName;
    }


    setUndoRedoAccess() {
        const undoEl = $('#dashboardUndo');
        const redoEl = $('#dashboardRedo');

        undoEl.removeClass('disabled pf-disable disabledLink');
        redoEl.removeClass('disabled pf-disable disabledLink');

        if (!undoService.hasUndo()) {
            undoEl.addClass('disabled pf-disable disabledLink');
        }

        if (!undoService.hasRedo()) {
            redoEl.addClass('disabled pf-disable disabledLink');
        }

        if (undoEl.length) {
            undoEl.prop('title', undoService.undoText);
        }

        if (redoEl.length) {
            redoEl.prop('title', undoService.redoText);
        }
    }

    childIndentStr(objList, obj) {

        const fnFindParentGroupOfObject = ((ls, ob) => {
            let parent = null;
            ls.forEach((v) => {
                if (v.id === ob.groupId) {
                    parent = v;
                    return false;
                }
            });
            return parent;
        });

        const fnComputeIndentStr = ((ls, ob, indentStr = '') => {
            if (!ob.groupId) {
                // Break out of recursion
                return indentStr;
            }

            // Chase groupId link, if any. Parent could be null;
            const parent = fnFindParentGroupOfObject(ls, ob);

            // Box chars used to form indent UTF text
            const
                boxDrawningsHorizontal = '&#9472;',
                boxDrawingsUpAndRight = '&#9492;';

            // Accumulated result: an HTML UTF text string
            const newIndentStr = indentStr ? indentStr + boxDrawningsHorizontal : boxDrawingsUpAndRight;

            // Recurse until no parent link
            return fnComputeIndentStr(ls, parent, newIndentStr);
        });

        return fnComputeIndentStr(objList, obj);
    }

    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // PF-4053 Utility for calling async functions in sequence.
    promiseSerial(functions) {
        return functions.reduce((promise, func) =>
                promise.then(result => func()),
            Promise.resolve([]))
    }

    //==================================================================================================
    // dateStr is assumed to be a standard JS date string in the UTC timezone.
    // Returns a standard JS date string in current time zone, formatted either as in the Flash app,
    // or in current locale. The formatParm governs formatting. It defaults to a Flash-app duplicate
    // setting.ß
    // Format codes: https://momentjs.com/docs/#/displaying/
    // If it is a falsey value (0, '', null, undefined, {}) the method uses toLocatString() formatting.
    //
    // Note that the current timezone does not have to be an integer hour offset from UTC.
    // Zones on fractional-hour boundaries will operate correctly.
    //==================================================================================================
    toLocalDateTime(dateStr, formatParm = 'DD MMM YYYY HH:mm') {
        const
            date = new Date(this.dateForIE(dateStr)),
            d = date.addMinutes(-date.getTimezoneOffset()),
            fd = formatParm ? new Moment(d).format(formatParm) : d.toLocaleString();
        return fd;
    }

    dateForIE(dateStr){
        return dateStr ? dateStr.toString().replace(/-/g,'/') : dateStr;
    }

    saveGridScrollPos(model, selector='.ui-jqgrid-bdiv.ui-corner-bottom'){
        const $jqGridObject = $(selector);
        let newPos = $jqGridObject.scrollTop();
        if (model) {
            if (model.get('newRowAdded')) {
                newPos = $jqGridObject[0].scrollHeight;
            }
            model.set('currentScroll', newPos, constants.MODEL_SILENT);
            model.unset('newRowAdded', constants.MODEL_SILENT);
        }
    }

    setGridScrollPos(model, selector='.ui-jqgrid-bdiv.ui-corner-bottom'){
        if (model) {
            $(selector).scrollTop(model.get('currentScroll'));
        }
    }
    
    isGroupContainer (factory) {
        const controls = ['control_checkbox_group', 'control_radio_button_group', 'control_group'];   
        return controls.find(c => c === factory) !== undefined;
    }

    updateAppReportVersion(version, isPublished, isMajorVersion){        
        if (isPublished){
            if (isMajorVersion){
                listService.dashboardLayout.mainPanelView.model.set('publishedVersion', version, constants.MODEL_SILENT);
                listService.dashboardLayout.mainPanelView.model.set('deployedVersion', version, constants.MODEL_SILENT);
            }
            
            listService.dashboardLayout.mainPanelView.model.set('version', 'published', constants.MODEL_SILENT);
            listService.dashboardLayout.mainPanelView.model.set("IsDeployed", true, constants.MODEL_SILENT);
            $('ul.document-info .status').text(constants.PUBLISHED);
        }

        if(!isPublished || isMajorVersion){
            $('ul.document-info .version').text(version);
        }
        
        $('.prop-main-form-name .version').text(version);

        listService.dashboardLayout.mainPanelView.model.set('latestVersion', version, constants.MODEL_SILENT);
        const currentFormModel = listService.currentForm.model;        
        currentFormModel.set('version', version, constants.MODEL_SILENT);
    }

    printHeader(model) {

        const mpvModel =  model;
        const versionSelected = mpvModel.get('version');
        const publishedVersion = mpvModel.get('deployedVersion') || mpvModel.get('publishedVersion');
        const draftVersion = mpvModel.get('draftVersion');

        let currentStatus = constants.UNPUBLISHED;
        let numberVersion = mpvModel.get('latestVersion');

        if (publishedVersion && (versionSelected === 'published' || versionSelected === 'latest')) {
            currentStatus = constants.PUBLISHED;
            numberVersion = publishedVersion;
        } else if (versionSelected === 'draft') {
            currentStatus = constants.DRAFT;
            numberVersion = draftVersion;
        }

        let formName = mpvModel.get('reportName') || mpvModel.get('formName');
        
        $('ul.document-info .status').text(currentStatus);
        $('ul.document-info .version').text(numberVersion);
        $('.title-pane .doc-title').text(formName);

        if (!listService.wasDesginerOpened) {
            $(window).on('resize', (e) => {
                let titlePane = $('.title-pane');
                let toolbarGroup = $(".control-groupbar");
                let nameOfForm = titlePane.find('.doc-title');
                let versionForm = titlePane.find('.version');
                let toolBar = $('.topbar-tools');
                //let displayStyle =  'table-cell';

                const minWidthToShrink = 575;
                const nameMaxSize = 20;
                const versionMaxSize = 10;

                nameOfForm.removeClass('header-ellipsis');
                versionForm.removeClass('header-ellipsis').css('max-width', '').prop('title', '');

                if (toolbarGroup.width() === minWidthToShrink) { 

                    if (nameOfForm.text().length >= nameMaxSize) {
                        nameOfForm.addClass('header-ellipsis');
                    }

                    if (versionForm.text().length >= versionMaxSize) {
                        const text = versionForm.text();
                        versionForm.parent().css({'display': 'flex', 'margin-right': 20});
                        versionForm.addClass('header-ellipsis').css({'max-width': 50}).prop('title', text);
                    } 
                }   
            });

            listService.wasDesginerOpened = true;
        }
    }

    get isLoggedIn(){
        return window.sessionStorage.getItem('isLoggedIn') ? window.sessionStorage.getItem('isLoggedIn') : false;
    }

    set isLoggedIn(isLoggedIn){
        window.sessionStorage.setItem('isLoggedIn', isLoggedIn);
    }

    navigateToLogin() {    
        window.localStorage.clear();
        window.sessionStorage.clear();
        listService._activeDashboardTab = '';
        sessionStorage.setItem('timesGreetingWindowOpened', 0);
        undoService.clearChangeTracker();
        if(listService.logoutRedirect && listService.logoutRedirect !== ''){
            window.location.href = listService.logoutRedirect;
        }else{

            //PF-10112 if it has parameters remove them
            if(window.location.search != ""){
                window.location.href = window.location.href.split('?')[0];
            }
            else{
                Backbone.history.navigate('/', { trigger: true });
            }
        }
        
    }
    
    isChart(factoryKey){
        return ['control_value', 'control_data_list', 'control_data_grid', 'control_bar_chart', 
                'control_gauge_chart', 'control_line_chart', 'control_pie_chart', 'control_crosstab'].includes(factoryKey);
    }

    makePanelFit() {
        let bodyHeight = $('body').height();
        let topBarHeight = $('header.topbar').height();
        let toolBarHeight = $('#toolbar-pane').height();
        let activeBehaviorsHeight = $("#activeBehaviors").height();
        let rightTail = $('#right-rail');
        let newHeight = bodyHeight - topBarHeight - toolBarHeight - 15;

        const panelHeaderHeight = 30;

        $('#layout-frame').height(newHeight - activeBehaviorsHeight - 8);
        rightTail.height(newHeight - panelHeaderHeight);
        $('#thumbnail-pane div.left-rail').height(newHeight - panelHeaderHeight);

        const breadCrumbHeight = rightTail.find('div.breadcrumb').height();
        const railHeaderHeight = rightTail.find('div.rail-header').height();
        newHeight -= (breadCrumbHeight - railHeaderHeight - 40)
        rightTail.find('div.right-rail-content').height(newHeight);
    }


    createResizable (element, direction, minWidth, additional = {}) {
        let options = {
            handles: direction,
            minWidth: minWidth
        };

        options = Object.assign(options, additional)
        element.resizable(options);

        element.find('.ui-resizable-handle ').append('<div class="handler"></div>');
    }

    displayChildren(e, style) {
        e.css('display', style);
    }

    hideIcons(help, minWidth, size) {
        let helpIcon = help.find('.rail-header .help'),
        textHeader = help.find('.rail-header h2');

        helpIcon.css('display', 'block');
        textHeader.removeClass('hide-title');
        if (size <= minWidth) {
            helpIcon.css('display', 'none'); 
            textHeader.addClass('hide-title');
        }  
    }

    createResizeCallBack (e, s, h) {
        let elem = e, style = s, help = h;
        const that = this;
        let linkToggle = help.find('.rail-header .open-panel');
        let toggleIcon = linkToggle.find('i');

        return function(event, ui) {
            $(this).css('left', 0); 
            const isLeftPanel = $(ui.originalElement).hasClass('left-cell');
            const hideIconsAt = 60;
            let props;
            let isExpanded = ui.size.width >= hideIconsAt;
            props = that.getPanelIcons(isLeftPanel, !isExpanded);

            //saving last width of the panels
            that.setPanelAttrs(isLeftPanel, { 
                width: ui.size.width, 
                addClass: props.addClass, 
                removeClass: props.removeClass, 
                isExpanded
            });
           
            that.displayChildren(elem, isExpanded ? style : 'none');
            that.hideIcons(help, hideIconsAt, ui.size.width);

            toggleIcon
            .removeClass(props.removeClass)
            .addClass(props.addClass);

            linkToggle.data("open", isExpanded);
            that.resizeGridWidth();
        }
    } 

    doPanelResizable() {
        this.createResizable($("#thumbnail-pane"), 'e', constants.MIN_PANEL_LEFT_WIDTH, {
            maxWidth: constants.MAX_PANEL_LEFT_WIDTH,
            resize: this.createResizeCallBack($('.left-rail-content'),
                'block', $('.left-cell'))
        });

        this.createResizable($(".property-pane"), 'w', constants.MIN_PANEL_RIGHT_WIDTH, {
            maxWidth: constants.MAX_PANEL_RIGHT_WIDTH,
            resize: this.createResizeCallBack($('.right-rail-content'),
                'block', $('.right-cell'))
        });
    }

    setPanelAttrs(isLeftPanel, attrs) {
        if (isLeftPanel) {
            listService.panels.left = attrs;
        }
        else {
            listService.panels.right = attrs;
        }
    }

    getPanelIcons(isLeftPanel, isExpanded) {
        let attrs = {};

        if (!isExpanded) {
            attrs =  isLeftPanel ? {
                removeClass: 'pf-double-carot-right',
                addClass: 'pf-double-carot-left',
                style: 'block'
            } : {
                removeClass: 'pf-double-carot-left',
                addClass:  'pf-double-carot-right',
                style: ['inline-block', 'inline-block', 'block']
            }
        }
        else {
            attrs = isLeftPanel ?  {
                removeClass: 'pf-double-carot-left',
                addClass: 'pf-double-carot-right', style: 'none'
            } : {
                removeClass: 'pf-double-carot-right',
                addClass: 'pf-double-carot-left', style: 'none'
            }
        }

        return attrs;
    }

    isPanelExpanded(target){
        let id = target.data().target;
        id = id.indexOf(".") == 0 ? id.substr(1) : id;
        id = id.indexOf("#") > -1 ? id : '#' + id;
        
        const targetElement = target ? $(id) : "";
        let attr = targetElement.attr('aria-expanded') || targetElement.css("display") !== "none";//If the expanded attribute does not exists check the visibility of the panel, use as fallback
        
        return this.isTrue(attr);
    }

    toggleIcon(e, rotate) {

        const target = e.currentTarget.getAttribute('data-target');
        const self = $(e.currentTarget);
        const icon = self.find('i');
        let collapsedIcon = 'pf-carot-left';

        if(target.indexOf("objects-page-group") > -1 || rotate){
            collapsedIcon = 'pf-carot-left pf-rotate-icon';
        }

        if (icon.length) {
            this.togglePanel(self,icon, collapsedIcon);
        }
    }

    togglePanel(target, icon, collapsedIconClass) {

        let collapsedIcon = collapsedIconClass || 'pf-carot-left'; //pf-carot-left is default collapsed icon

        //Set a timeout to give time for the panel to collapse or expand and change the icon accordingly
        setTimeout(() => {
            if (this.isPanelExpanded(target)) {
                //Avoid using toggles because multiple clicks caused the icons to behave erratically
                icon.removeClass(collapsedIcon);
                icon.removeClass('pf-rotate-icon'); //Do not rotate the down arrow
                icon.addClass('pf-carot-down');
                
            } else {
                icon.removeClass('pf-carot-down');
                icon.addClass(collapsedIcon);
                target.parent().removeClass("expanded-page");
            }

            if (listService.mainKind !== constants.KIND_MOBILE) {
                leftPanelStateService.savePages();
            }

        }, 5);
    }

    setPanelSize() {
        if (!listService.panels) {
           this.setPanelDefaults();
        }

        let elem, 
            left = listService.panels.left,
            right = listService.panels.right; 

        $(".left-cell").width(left.width);
        $(".property-pane").width(right.width);

        this.propPanelRender($('.left-cell'), left);
        if (left.width <= constants.MIN_PANEL_LEFT_WIDTH) { 
            this.displayChildren($('.left-rail-content'), 'none'); 
        }
        this.hideIcons($('.left-cell'), constants.MIN_PANEL_LEFT_WIDTH, left.width); 

        this.propPanelRender($('.right-cell'), right);
        if (listService.panels.right.width <= constants.MIN_PANEL_RIGHT_WIDTH) { 
            this.displayChildren($('.right-rail-content'), 'none');
        }
        this.hideIcons($('.right-cell'), constants.MIN_PANEL_LEFT_WIDTH, right.width); 
    }

    propPanelRender(elem, props) {
        if (elem) {
            let linkToggle = elem.find('.rail-header .open-panel');
            let toggleIcon = linkToggle.find('i');

            toggleIcon
                .removeClass(props.removeClass)
                .addClass(props.addClass); 

            linkToggle.data("open", props.isExpanded);
        }
    }

    setPanelDefaults() {
        listService.panels = {
            left: { width: 320 }, 
            right: { width: 320}
        };

        constants.max_left_width = 420;
        constants.max_right_width = 420;

        if ($(window).width() <= 1240) {
            constants.max_left_width = 260;
            constants.max_right_width = 280;
            listService.panels = {
                left: { width: 260 }, 
                right: { width: 280}
            };
        } 
    }

    setWidthConstants() { 
        if (listService.panels) {
            let max_left_width = 420;
            let max_right_width = 420;
            if ($(window).width() <= 1240) {
                max_left_width = 260;
                max_right_width = 280;
            } 

            if (max_left_width !== constants.max_left_width) {
                $("#thumbnail-pane").resizable( "option", "maxWidth", max_left_width );
                $(".property-pane").resizable( "option", "maxWidth", max_right_width );

                constants.max_left_width = max_left_width;
                constants.max_right_width = max_right_width;
            }
        }
    }

    showAlert(title, text, size){
        const confirmView = new AlertDialogView({
            model: new Model({
                text: text,
                title: title,
                height: size
            })
        });
        confirmView.render();
    }

    // PF-4874.
    // Warning. The argument param id is the connectionVO.id, but the _behaviorConnections map id is a composite:
    // <connectionVO.scriptId>-<connectionVO.id>
    // It's best to centralize an adapter here instead of fixing the mismatch among several callers:
    // Filter the small collection for the first connectionVO having connectionVO.id (there's only one).
    // Create the composite deletion ID from the scriptId and id of that connectionVO.
    destroyBehaviorConnnection(listService, id ) {
        // Sometimes id is already a composite. Other times it is not and we must create it. (Sigh)
        let compositeId = id;
        if (!id.includes('-')) {
            const connectionVO = listService._behaviorConnections.filter(w => w.id === id).first();
            if(connectionVO) {
                compositeId = `${connectionVO.scriptId}-${connectionVO.id}`;
            }
        }

        const undoMemo = listService._behaviorConnections.get(compositeId);
        listService._behaviorConnections = listService._behaviorConnections.delete(compositeId);
        return undoMemo; // so we can track them in UNDO
    }

    updatePropertyRenderAndSendEvent(propName,propVal,model,renderFunc,event){

        let currentSelected;

        if (listService.selectedCount) {
            currentSelected = Immutable.Map(listService.selected);
            listService.selected.forEach(view => {
                view.model.set(propName, propVal, { silent: true });
                
            });
        }

        model.set(propName,propVal,{silent:true});
        renderFunc();
        eventBus.trigger(event);
    }

    showScrollOnPanel (tabContentwidth = 235, minWidth = 275) {
        let settingsProps =  $('.settings-style-access');
        $('.tabContent').css('min-width', tabContentwidth);
        settingsProps.css('min-width', minWidth);
        settingsProps.find('.prop-detai').css('min-width', tabContentwidth);
        settingsProps.find('.prop-detail').css('min-width', tabContentwidth); 
    }

    escapeXMLChars(value){
        return value.replace(/&/g, '&amp;amp;')
            .replace(/</g, '&amp;lt;')
            .replace(/>/g, '&amp;gt;')
            .replace(/"/g, '&amp;quot;');
    }

    escapeXMLEntities(value){
        return value.replace(/;/g, '&#59;')
            .replace(/&/g, '&amp;')
            .replace(/\+/g, '&#43;')
            .replace(/,/g, '&#44;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/\//g, '&#47;')
            .replace(/\\/g, '&#92;')
            .replace(/"/g, '&#34;'); 
    }

    prepareComboWidget($el, model) {
        let selfThis = model;
        let id = model.el.id;

        $.widget("custom.combobox", {
            options: {
                controlId: '',
                value: 0,
                model: 0
            },

            _create: function () {
                this.wrapper = $("<span>")
                    .attr('id', 'theme-combobox-' + id)
                    .addClass("custom-combobox")
                    .insertAfter(this.element);

                this.element.hide();
                this._createAutocomplete(this.options);
                this._createShowAllButton();
            },

            _createAutocomplete: function (options) {

                this.input = $("<input>", {
                    maxLength: 3
                })
                    .appendTo(this.wrapper)
                    .addClass("custom-combobox-input ui-widget ui-widget-content ui-corner-left")
                    .val(options.value)
                    .autocomplete({
                        classes: {
                            "ui-autocomplete": "custom-autocomplete"
                        },
                        delay: 0,
                        minLength: 0,
                        source: $.proxy(this, "_source"),
                        appendTo: $el,
                        search: options.value
                    });

                this._on(this.input, {
                    input: function (e, param) {
                        var value = e.currentTarget.value.replace(/[^0-9]/g, '');

                        this.input.val(value);
                        this.element.val(value);

                        this.input.autocomplete("search", value);
                    }, //PF-2105 - Forms/Reports - Font size (general)
                    change: function(e, param){
                        const ogDropDown = e.currentTarget.parentElement.parentElement.querySelector(this.options.controlId);
                        const name = ogDropDown.name;
                        let value = e.currentTarget.value.replace(/[^0-9]/g, '');
                        const dataKey = ogDropDown.attributes["data-key"] ? ogDropDown.attributes["data-key"].value : '';
                        this._trigger("change", null, { value: value });
                        this._trigger("select", e, { item: value });
                        selfThis.updateSelectAttributes(event, name, value, dataKey);                     
                    },
                    autocompleteselect: function (event, ui) {
                        const ogDropDown = event.currentTarget.parentElement.parentElement.querySelector(this.options.controlId);
                        const name = ogDropDown.name;
                        const dataKey = ogDropDown.attributes["data-key"] ? ogDropDown.attributes["data-key"].value : '';
                        let value =  ui.item.value;
                        ui.item.option.selected = true;
                        this._trigger("change", null, { value: value });
                        this._trigger("select", event, { item: ui.item.option });
                        selfThis.updateSelectAttributes(event, name, value, dataKey);
                    }
                });
            },

            _createShowAllButton: function () {
                var input = this.input,
                    wasOpen = false;

                $("<a>")
                    .attr("tabIndex", -1)
                    .appendTo(this.wrapper)
                    .button({
                        icons: {
                            primary: "ui-icon-triangle-1-s"
                        },
                        text: false
                    })
                    .removeClass("ui-corner-all")
                    .addClass("custom-combobox-toggle ui-corner-right")
                    .on("mousedown", function () {
                        wasOpen = input.autocomplete("widget").is(":visible");
                    })
                    .on("click", function () {
                        input.trigger("focus");

                        // Close if already visible
                        if (wasOpen) {
                            return;
                        }
                        // Pass empty string as value to search for, displaying all results
                        input.autocomplete("search", "20");
                    });
            },

            _source: function (request, response) {
                response(this.element.children("option").map(function () {
                    var text = $(this).text();
                    return {
                        label: text,
                        value: text,
                        option: this
                    };
                }));
            },

            _destroy: function () {
                this.wrapper.remove();
                this.element.show();
            }
        });
    }

    resolveCompliantFontFamilyName(fontFamily){
        let result = fontFamily;
        if (fontFamily){
            let regX = /[\s0-9,;.]/g
            let found = fontFamily.match(regX);
            if (found && found.length > 0){
                result = "'" + fontFamily + "'";
            }
        }

        return result;
    }

    roundCeilAbsolute(value){
        const _roundedValue = value > 0 ? Math.ceil(value) : Math.floor(value);
        return  _roundedValue ? _roundedValue : 0;
    }

    newShade (hexColor, magnitude){

        if(hexColor){
            hexColor = hexColor.replace(`#`, ``);
            if (hexColor.length === 6) {
                const decimalColor = parseInt(hexColor, 16);
                let r = (decimalColor >> 16) + magnitude;
                r > 255 && (r = 255);
                r < 0 && (r = 0);
                let g = (decimalColor & 0x0000ff) + magnitude;
                g > 255 && (g = 255);
                g < 0 && (g = 0);
                let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
                b > 255 && (b = 255);
                b < 0 && (b = 0);
                return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
            } else {
                return hexColor;
            }
        }
    }
    
    //PF-9818 function to get the help videos urls from the php files
    getURLFromPHP(url) {
        let result = null;
        $.ajax(
            {
                url: url,
                type: 'get',
                dataType: 'html',
                async: false,
                cache: false,
                success: function(data)
                {
                    result = data;
                }
            });

        return result;
    }

    getURLFromPHPAsync(url) {
        return new Promise((resolve, reject) => {
          $.ajax({
            url: url,
            type: 'get',
            dataType: 'html',
            cache: false,
            success: function(data) {
              resolve(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              reject(errorThrown);
            }
          });
        });
      }

    get navigateToPage(){
        
        let navigateTo = false;

        //PF-10112 check if there is a state param to load the last view
        const queryString = window.location.href;   
        const url = new URL(queryString);
        const searchParams = url.searchParams;
        
        if(searchParams.has("state")){
            navigateTo = searchParams.get("state");
            navigateTo = navigateTo.split(".");
        }
        
        return navigateTo;
    }

    newDashboardModal(id, options) {

        const titleBar = options.hideTitleBar ? "dashboard-modal-dialog-titlebar-hidden" : options.titleBarClass || "dashboard-modal-dialog-titlebar";
        const dialog = $(id).dialog({
            autoOpen: false,
            height: "auto",
            maxHeight: options.maxHeight || "auto",
            dialogClass: options.dialogClass || "no-close",
            closeOnEscape: options.closeEsc || false,
            minHeight: 150,
            title: options.title,
            width: options.width || 630,
            modal: options.modal || true,
            resizable: options.resizable || false,
            minWidth: options.minWidth || 630,
            buttons: options.buttons,
            classes: {
                "ui-dialog": "dashboard-modal-dialog",
                "ui-dialog-titlebar": titleBar,
                "ui-dialog-title": options.titleClass || "dashboard-modal-title",
                "ui-dialog-content": options.dialogContentClass || "dashboard-modal-content"
            },
            close: options.closeFx,
            open: function (event, ui) {
                
                if (options.closeEsc) {
                    $('.ui-widget-overlay').on('click', function () {
                        dialog.dialog('close');
                    });
                }

                if (options.resize) {
                    const maxHeight = window.innerHeight - 40;
                    dialog.dialog("option", "maxHeight", maxHeight);
                }

                if (options.allowMaximize) {
                    const $dialogContainer = dialog.closest('.ui-dialog');
                    const $titlebar = $dialogContainer.find('.ui-dialog-titlebar');

                    // Create the maximize button
                    const $maxIcon = $(
                        '<i class="pf-icon-maximize dialog-maximize-icon" title="Maximize"></i>'
                    );
                  
                    // Add the button to the title bar
                    $titlebar.prepend($maxIcon);

                    // Add the click handler
                    $maxIcon.on('click', function () {
                        const $icon = $(this);
                        const isMaximized = $dialogContainer.data('isMaximized');

                        if (isMaximized) {
                            // RESTORE
                            const old = $dialogContainer.data('oldState');

                            dialog.dialog('option', {
                                'height': old.height,
                                'width': old.width,
                                'position': old.position,
                                'resizable': old.resizable,
                                'draggable': old.draggable
                            });

                            $dialogContainer.data('isMaximized', false);
                            $maxIcon.attr('title', 'Maximize');
                            $icon.removeClass('pf-icon-minimize').addClass('pf-icon-maximize');
                        } else {
                            // MAXIMIZE
                            
                            // Store the current state
                            $dialogContainer.data('oldState', {
                                height: dialog.dialog('option', 'height'),
                                width: dialog.dialog('option', 'width'),
                                position: dialog.dialog('option', 'position'),
                                resizable: dialog.dialog('option', 'resizable'),
                                draggable: dialog.dialog('option', 'draggable')
                            });

                            dialog.dialog('option', {
                                'height': $(window).height() - 40,
                                'width': $(window).width() - 40,
                                'position': { my: "center", at: "center", of: window },
                                'resizable': false,
                                'draggable': false
                            });

                            $dialogContainer.data('isMaximized', true);
                            $maxIcon.attr('title', 'Minimize');
                            $icon.removeClass('pf-icon-maximize').addClass('pf-icon-minimize');
                        }

                        setTimeout(() => {
                            if (typeof options.onResizeCallback === 'function') {
                                options.onResizeCallback();
                            }
                        }, 50);
                    });
                }
            }
        });

        return dialog;
    } 
    
    //This function makes sure that URL end with a single slash
    enforceSingleEndSlash(url){
        let _url = url;
        if (!_.endsWith(_url, '/')){
            _url += '/';
        }

        return _url;
    }

    copyValue(txtId) {		  
        let copyText = document.getElementById(txtId);
        copyText.select();
        if(navigator.clipboard){
            navigator.clipboard.writeText(copyText.value);
        }else{
            notificationService.warning('The clipboard is not accessible on this browser, likely due to security restrictions.');
        }
    }

    validateMultipleEmails(emailInput, separator, max) {

        let emails = emailInput;
        emails = emails.split(separator);

        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let invalidEmails = [];

        const validMax = emails.length - max;

        if (validMax > 0) {
            invalidEmails = "Only " + max + " emails are allowed. Please remove " + validMax + " email account" + validMax === 1 ? "." : "s.";
        } else {

            for (let i = 0; i < emails.length; i++) {

                emails[i] = emails[i].trim();
                if (emails[i] == "" || !regex.test(emails[i])) {
                    invalidEmails.push(emails[i]);
                }
            }
        }

        return invalidEmails;
    }

    detectURLs(message) {
        const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return message.match(urlRegex)
    }

    createIdForControlName(val, factory){
        let type = "";
        switch (factory){
            case 'control_text':
                case 'control_small_text':
                case 'control_large_heading':
                case 'control_medium_heading':
                case 'control_small_heading':
                case 'control_link':
                    type = "Label";
                break;
            case 'control_button':
            case 'control_submit_button':
            case 'control_print_button':
            case 'control_play_form_button':
            case 'control_play_report_button':
            case 'control_clear_filter_button':
            case 'control_page_button':
                type = "Button";
            break;
            case 'control_checkbox':
                type = "Check";
            break;
            case 'control_radio_button':
                type = "Radio";
            break;
            case 'control_text_input':
            case 'control_multiple_text_input':
            case 'control_numeric_input':
            case 'control_password_input':
                type = "Input"
            break;
            default:
                type = "";
                break;

        }

        let pascalCase = _.upperFirst(_.camelCase(val)).slice(0, 20);
        pascalCase += "_" + type + sequenceService.getControlNumber();
       return pascalCase;
    }

    popupWindow(url, win, w, h) {
        const y = win.top.outerHeight / 2 + win.top.screenY - ( h / 2);
        const x = win.top.outerWidth / 2 + win.top.screenX - ( w / 2);
        return win.open(url, "popup", `popup=true, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
    }

    setAppNewName(name){
        listService.formBase.name = name;
        $(".app-name").val(name);
        $('.title-pane .doc-title').text(name);
        $('.rail-header-text').text(name + constants.RIGHT_PANEL_PROPERTIES_TITLE);
    }

    sanitizeHTML(inputHTML, full, oldVal, allowHTML) {

        let cleanNodes = "";

        if (inputHTML && inputHTML !== "") {
            // Clean the body content of the parsed document
            if (full) { //Only run this method in for single value check (not trees) since it may have performance issues but is more secure than regex     
                // Valid HTML tags to avoid tags like <onload> to be treated like nodes
                let htmlTags = [
                    'div', 'span', 'p', 'a', 'img', 'ul', 'ol', 'li', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'tfoot',
                    'b', 'i', 'u', 'em', 'strong', 'br', 'hr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
                    'blockquote', 'code', 'pre', 'small', 'sub', 'sup', 'textarea', 'input', 'button',
                    'header', 'footer', 'section', 'article', 'aside', 'nav', 'main',
                    'figure', 'figcaption', 'address', 'dl', 'dt', 'dd',
                    'label', 'fieldset', 'legend', 'datalist', 'optgroup', 'option', 'select', 'output', 'progress', 'meter',
                    'details', 'summary', 'dialog',
                    'abbr', 'cite', 'kbd', 'mark', 'q', 's', 'samp', 'time', 'var', 'del', 'ins',
                    'script', 'style', 'iframe', 'embed', 'link', 'applet', 'video', 'audio', 'noscript', 'meta', 'base',
                    'canvas', 'picture', 'source', 'track', 'map', 'area',
                    'data', 'template', 'slot'
                ];
                const validTagRegex = new RegExp(`</?(${htmlTags.join('|')})\\b[^>]*>`, 'gi');
                const tagRegex = /<\/?[^>]+>/g;

                // Step 2: Escape invalid tags
                inputHTML = inputHTML.replace(tagRegex, (tag) => {
                    return validTagRegex.test(tag) ? tag : tag.replace(/</g, '<').replace(/>/g, '>');
                });

                // Helper function to recursively clean elements
                const cleanNode = (node) => {

                    // Recursively clean child nodes
                    Array.from(node.childNodes).forEach(cleanNode);

                    if (node.nodeType === Node.ELEMENT_NODE) {

                        if (allowHTML) { //if html should be allowed only remove unsafe tags, otherwise remove all tags
                            // Remove blacklist unsafe tags
                            htmlTags = [
                                'script', 'embed', 'object', 'applet', 'audio',
                                'source', 'track', 'canvas', 'picture',
                                'style', 'link', 'meta', 'base',
                                'form', 'input', 'textarea',
                                'select', 'option',
                                'bgsound', 'marquee', 'isindex',
                                'frame', 'frameset', 'noscript'
                            ];
                        }

                        if (htmlTags.includes(node.tagName.toLowerCase())) {
                            const parent = node.parentNode;
                            if (parent) {
                                // Insert text content of the dangerous node before replacing
                                const textNode = document.createTextNode(node.textContent);
                                parent.replaceChild(textNode, node);
                            }
                        }

                        // Sanitize attributes
                        if (node.attributes) {
                            for (let attr of [...node.attributes]) {
                                const attrName = attr.name.toLowerCase();
                                const attrValue = attr.value;

                                // Handle inline event handlers (e.g., onclick)
                                if (attrName.startsWith('on')) {
                                    node.setAttribute(attr.name, ''); // Clear the content of the attribute
                                }

                                // Handle dangerous protocols in href and src
                                if (['src', 'href'].includes(attrName)) {
                                    if (/^(javascript|vbscript|data):(?!image\/(png|jpeg|gif|webp))/.test(attrValue)) {
                                        node.setAttribute(attr.name, ''); // Clear unsafe values
                                    }
                                }

                                // Handle unsafe styles
                                if (attrName === 'style') {
                                    if (/url\s*\(\s*['"]?\s*(javascript|vbscript|data:)/i.test(attrValue)) {
                                        node.setAttribute(attr.name, ''); // Clear unsafe style values
                                    }
                                }

                                // Handle unsafe tags
                                if (attrName === 'value') {
                                    if (/<\/?(script|style|iframe|object|embed|link|applet|noscript)[^>]*>/gi.test(attrValue)) {
                                        node.setAttribute(attr.name, ''); // Clear unsafe style values
                                    }
                                }
                            }
                        }

                    } else if (node.nodeType === Node.TEXT_NODE) { //if it is just text and not an html tag remove potentially dangerous protocols and events

                        // Remove dangerous protocols in attributes like javascript:
                        node.textContent = node.textContent.replace(/\b(javascript|vbscript|data|file|ftp|telnet|mailto|about|chrome|ms-settings)\s*:/gi, '');

                        //Remove dangerous events (must have an '=' and single or double quotes to avoid false positives)
                        node.textContent = node.textContent.replace(/on[a-z]+\s*=\s*(['"])/i, '');

                        //failsafe in case any of the blacklist tag passes
                        node.textContent = node.textContent.replace(/<\/?(script|style|iframe|object|embed|link|applet|noscript)[^>]*>/gi, '');

                    }
                }

                // Create a DOMParser to parse the input HTML string
                const parser = new DOMParser();
                const doc = parser.parseFromString(inputHTML, 'text/html');
                Array.from(doc.childNodes).forEach(cleanNode);

                if (doc.body.childNodes.length > 0) {

                    if(allowHTML){
                        cleanNodes = doc.body.innerHTML;
                    }
                    else{
                        cleanNodes = doc.body.innerText;
                    }
                } else {
                    cleanNodes = doc.childNodes[0].innerText;
                }
            }
            else { //Use regex for tree and behaviors for an additional layer of protection

                const cleanHTMLString = (inputHTML) => {

                    // Remove the opening tag and preserve the content
                    inputHTML = inputHTML.replace(/<\s*(script|iframe|object|embed|style|link)[^>]*>/gi, '');

                    // Remove the closing tag
                    inputHTML = inputHTML.replace(/<\s*\/\s*(script|iframe|object|embed|style|link)\s*>/gi, '');

                    // Remove only valid inline event handlers (e.g., onclick, onload)
                    inputHTML = inputHTML.replace(/\s*on[a-zA-Z0-9_]+\s*=\s*(['"])[^'"]*\1/gi, '');

                    // Remove dangerous protocols in attributes like javascript:
                    inputHTML = inputHTML.replace(/\b(?:href|src|style)\s*=\s*(["']?)\s*(?:javascript:|vbscript:|data:(?!image\/(png|jpeg|gif|webp)))[^'"]*\1/gi, '');

                    return inputHTML;
                }


                cleanNodes = cleanHTMLString(inputHTML)
            }

            if (cleanNodes.trim() === "") {//in case the text is empty because of the validations use the previous value
                cleanNodes = oldVal;
            }
        }

        // Return the sanitized inner HTML
        return cleanNodes;
    }

    removeScriptsFromHTMLString(htmlString) {
        let processedHTML = '';
        if (htmlString){
            processedHTML = htmlString.replace(/<script[^>]*>(.*?)<\/script>/ig, "");
        }

        return processedHTML;
    }

    getLocalizedText(id, prop) {

        if (!id) return null;

        if (listService.currentLanguage !== "default") {
            const item = listService.getTranslationObjectById(listService.getCleanedId(id));
            if (!item) return null;
            return item[prop]?.[listService.currentLanguage] ?? null;
        }
        return null;
    }

    isTranslationEnabled(){
        return listService.getAllLanguages().length > 0;
    }

    openMultilangManager(id, attribute){

        ReactModal.open(MultilingualContainer, {
            modalProps: {
                headerTitle: 'Multi-Language Management'
            },
            componentProps: {
                initialSelectedId: id,
                initialSelectedAttribute: attribute
            }
        });
    }

    downloadAsFile(content, filename) {
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

const util = new Util();
export default util;
